'use client'
import React, { createContext, useContext, useState, useEffect } from 'react'
import { THEMES } from '@/utils/constants'
import { track } from '@/utils/analytics'

const ThemeContext = createContext()

export function ThemeProvider({ children }) {
	const [activeTheme, setActiveTheme] = useState(THEMES.INDIGO)

	// Persistencia opcional: cargar tema de localStorage
	useEffect(() => {
		const savedThemeId = localStorage.getItem('config-strike-theme')
		if (savedThemeId) {
			const theme = Object.values(THEMES).find(t => t.id === savedThemeId)
			if (theme) setActiveTheme(theme)
		}
	}, [])

	const changeTheme = (themeId) => {
		const theme = Object.values(THEMES).find(t => t.id === themeId)
		if (theme) {
			setActiveTheme(theme)
			localStorage.setItem('config-strike-theme', themeId)
			track('feature_use', { feature: 'theme', value: themeId })
		}
	}

	return (
		<ThemeContext.Provider value={{ activeTheme, changeTheme, themes: Object.values(THEMES) }}>
			{children}
		</ThemeContext.Provider>
	)
}

export const useTheme = () => {
	const context = useContext(ThemeContext)
	if (!context) {
		throw new Error('useTheme must be used within a ThemeProvider')
	}
	return context
}
